/**
 * Compiled regular expression to validate a string is a JWT.
 *
 * The header and payload segments must start with "eyJ" (base64url of '{"'),
 * which every JWT does. Without that anchor, an Okta IDX state handle in its
 * bare form ("02.id.<id>", no "~c.<context>" suffix) also matches, and the app
 * then sends it as a Bearer token instead of an x-okta-idx-state-handle header
 * (CIAM-476).
 */
export const jwtRegex = /^eyJ[A-Za-z0-9_-]+\.eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]*$/;

/**
 * Tests if a string looks like a JWT.
 *
 * @param {string} token String to test
 * @returns {boolean} true if string looks like a JWT, false otherwise.
 */
function isTokenJwt(token: string) {
  return jwtRegex.test(token);
}

export default isTokenJwt;